import { useAuth } from './auth';

export default function Gate({ domain, any, all, fallback = null, children }) {
    const { can, canAny, canAll } = useAuth();
    let isAllowed = false;
    if (domain) isAllowed = can(domain);
    else if (any) isAllowed = canAny(...any);
    else if (all) isAllowed = canAll(...all);
    return isAllowed ? children : fallback;
}
